module.exports = "a";


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/evaluate/a.js
 ** module id = 1
 ** module chunks = 0
 **/